// removed by extract-text-webpack-plugin
module.exports = {"form":"Form__form___Ntjqa","field":"Form__field___1zD83","sigin":"Form__sigin___3FzvE","note":"Form__note___2TnPG","facebook":"Form__facebook___160o-","linkForgot":"Form__linkForgot___3cbaJ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Login/Form.scss
// module id = sSRa
// module chunks = 0